export interface NewsItem {
  id: string;
  cat: string;
  catName: string;
  title: string;
  excerpt: string;
  content: string[];
  time: string;
  read: string;
  comment: string;
  tag: string;
  hot: boolean;
  image: string;
  imgAlt: string;
}

export interface TimelineNode {
  time: string;
  title: string;
  desc: string;
  kind: "start" | "flow" | "deny" | "reverse" | "fresh";
}

export interface HotItem {
  rank: string;
  title: string;
  heat: string;
  trend: "up" | "down" | "new";
  tag: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const heroImages = {
  banner:
    "https://readdy.ai/api/search-image?query=Editorial%20collage%20background%20of%20a%20gossip%20newsroom%20wall%20with%20newspaper%20clippings%2C%20pinned%20photographs%2C%20colorful%20tape%2C%20question%20marks%20and%20magnifying%20glass%20sketches%2C%20warm%20cream%20and%20vermilion%20red%20palette%2C%20flat%20design%20vector%20style%2C%20clean%20composition%20with%20large%20empty%20space%20on%20left%20side%20for%20text%20overlay&width=1800&height=720&seq=hero-banner-g1&orientation=landscape",
};

export const newsItems: NewsItem[] = [
  {
    id: "g-2026-0901",
    cat: "deny",
    catName: "辟谣反转",
    title: "“直播停播半年”是误传，当事人已发长文还原时间线",
    excerpt:
      "一份被反复转发的“停播截图”被证实系旧闻拼接。本人发布时间线长文，标注了每一处误传节点，事件迎来第一轮反转。",
    content: [
      "近日一则“主播停播半年”的截图在多个群聊里被反复转发，并配文称“人已跑路、账号作废”。随着讨论持续发酵，事件热度一度冲上热搜榜前列。",
      "随后本人通过视频账号发布长文，逐条对照了截图里的时间与地点。文中指出，被转发的截图实际拍摄于去年，且画面中的背景与此前发布过的户外录播画面一致，属于旧素材拼接。",
      "在长文结尾，本人也晒出了近期的发布记录与工作排期，表示从未停更，只是降低了更新频率。原文发布两小时内，评论区涌入数千条留言，大多数网友认为“反转来得又快又完整”。",
      "目前，多个搬运账号已删除原视频。事件本身也从“辟谣”走向了“对信源核实”的讨论，更多网友开始关注转载链条里的第一发布者究竟是谁。",
    ],
    time: "2小时前",
    read: "12.6万",
    comment: "438",
    tag: "截图澄清",
    hot: true,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20a%20mobile%20phone%20screen%20with%20a%20red%20big%20checkmark%20and%20crossed%20out%20old%20newspaper%20clipping%2C%20flat%20vector%20gossip%20newsroom%20style%2C%20warm%20cream%20background%20with%20vermilion%20red%20accents%2C%20torn%20paper%20texture%2C%20clean%20minimal%20composition&width=900&height=680&seq=news-deny-01&orientation=portrait",
    imgAlt: "直播停播传闻辟谣截图澄清插画",
  },
  {
    id: "g-2026-0902",
    cat: "respond",
    catName: "当事人回应",
    title: "被卷入“幕后言论”争议后，该博主首次直播正面回应",
    excerpt:
      "面对持续三天的高讨论度，当事博主开直播回应了网传的幕后言论，承认情绪化表达欠妥，同时澄清了部分被断章取义的片段。",
    content: [
      "过去三天，一条疑似幕后私下言论的录音在多个平台传播，引发大量围观与解读。录音内容被拆分成若干片段，围绕“是否影射同行”的争论迅速升温。",
      "在直播开场，博主先还原了录音录制的背景与上下文，指出其中有几处关键话语被刻意截取，脱离了当时的聊天语境，容易造成误读。",
      "同时，他也坦承自己当时的表达确实不够严谨，情绪上头的措辞并不妥当，为此向受到困扰的同行和粉丝道歉。整场直播持续约一小时，弹幕从质疑逐渐转向理性讨论。",
      "事件至此，多数网友认可其“有回应、有认错、有澄清”的处理方式，也有声音认为后续仍需看实际言行是否一致。我们将持续跟进相关新瓜进展。",
    ],
    time: "5小时前",
    read: "28.3万",
    comment: "1206",
    tag: "直播回应",
    hot: true,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20a%20live%20streaming%20studio%20desk%20with%20microphone%20and%20camera%20and%20lighting%20ring%20light%2C%20flat%20vector%20gossip%20newsroom%20style%2C%20warm%20cream%20and%20vermilion%20red%20palette%2C%20clean%20minimal%20background&width=900&height=680&seq=news-resp-01&orientation=portrait",
    imgAlt: "博主直播正面回应争议插画",
  },
  {
    id: "g-2026-0903",
    cat: "fresh",
    catName: "新瓜速递",
    title: "团队透露：下月将有大动作，疑似联动头部创作者",
    excerpt:
      "工作室发布一张神秘剪影海报并配文“下月见”，评论区已有人根据剪影推测出可能的联动对象，新瓜呼之欲出。",
    content: [
      "昨晚九点，该账号工作室在社交平台发布了一张剪影海报：两位并肩站立的人形轮廓，配文只有三个字“下月见”。发布十分钟内转发即破万。",
      "细心的网友很快展开“破案”。有人指出左侧剪影的肩部曲线与此前某头部生活类博主的公开照片高度相似，还有人翻出两人半年前一次公开互动留下的伏笔。",
      "截至发稿，双方账号均未正面回应，只在本条动态下点赞了部分“猜对了”的评论，被网友解读为“默认式官宣”。",
      "若联动属实，这将是两位内容风格差异极大的创作者首次同框，业内普遍认为话题度与商业价值都不会低。后续进展我们将第一时间跟进。",
    ],
    time: "8小时前",
    read: "9.8万",
    comment: "672",
    tag: "神秘预告",
    hot: true,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20two%20silhouette%20profiles%20with%20a%20big%20yellow%20question%20mark%20between%20them%20and%20sparkles%2C%20flat%20vector%20gossip%20newsroom%20style%2C%20warm%20cream%20and%20amber%20palette%2C%20clean%20minimal%20background&width=900&height=680&seq=news-fresh-01&orientation=portrait",
    imgAlt: "神秘联动剪影预告新瓜插画",
  },
  {
    id: "g-2026-0904",
    cat: "progress",
    catName: "追踪进展",
    title: "“翻车事件”后续：品牌方已介入，双方各执一词",
    excerpt:
      "上月引发热议的带货翻车事件出现新进展，涉事品牌方发布声明表示已介入调查，而主播方则晒出合同截图回应。",
    content: [
      "上月，一起带货直播中被指“货不对板”的事件持续发酵。当时主播展示的样品与实际到手商品存在明显差异，引发了退货潮与大量吐槽。",
      "本月初，涉事品牌方首次发声，表示已成立专项小组介入调查，将核查仓库、物流与主播选品三个环节，预计两周内公布结果。",
      "紧接着，当事主播晒出部分合同截图，强调选品与品控条款在合同中已有明确约定，暗示责任划分并非单方面问题。双方声明措辞都较为克制，但指向明显不同。",
      "目前多方消息显示，第三方质检机构也已介入抽样。这起事件究竟会以“退款补偿”还是“追责赔偿”收场，仍需等待最终调查结论，我们会持续追踪。",
    ],
    time: "11小时前",
    read: "18.7万",
    comment: "934",
    tag: "带货调查",
    hot: false,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20a%20contract%20document%20with%20a%20magnifying%20glass%20and%20seal%20stamp%20and%20red%20arrows%2C%20flat%20vector%20gossip%20newsroom%20style%2C%20warm%20cream%20and%20vermilion%20red%20palette%2C%20clean%20minimal%20background&width=900&height=680&seq=news-prog-01&orientation=portrait",
    imgAlt: "带货翻车品牌介入合同调查插画",
  },
  {
    id: "g-2026-0905",
    cat: "deny",
    catName: "辟谣反转",
    title: "网传“退出短视频圈”不实，本人晒新片场照证实照常拍摄",
    excerpt:
      "有账号声称其将“转型退圈”，随后本人发布在片场的花絮照，并幽默回应“手机还能开机，没退”。二次反转完成。",
    content: [
      "一段声称“其已完成最后一场戏，将淡出短视频圈”的文字近日被多个营销号引用，配以模糊的旧图作为佐证，阅读量迅速攀升。",
      "就在传闻发酵当晚，该创作者本人更新动态，发布了一张片场工作花絮照：镜头前正在补拍夜戏，并配文“别瞎猜，手机还能开机，没退”。",
      "细心的网友随后发现，那条“退圈”文字最早的出处其实是某个娱乐资讯号，在没有任何信源的情况下进行的“剧情推演”，被层层转发后越传越真。",
      "该事件也再次提醒围观者：未经核实的“退圈”“停更”类消息，往往只是一次话题制造的产物。此类反转案例我们已经整理进辟谣专栏，可点击查看。",
    ],
    time: "昨日",
    read: "7.4万",
    comment: "289",
    tag: "二次反转",
    hot: false,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20a%20film%20camera%20on%20tripod%20on%20a%20movie%20set%20with%20clapperboard%2C%20flat%20vector%20gossip%20newsroom%20style%2C%20warm%20cream%20and%20vermilion%20red%20palette%2C%20clean%20minimal%20background&width=900&height=680&seq=news-deny-02&orientation=portrait",
    imgAlt: "退圈传闻辟谣片场拍摄插画",
  },
  {
    id: "g-2026-0906",
    cat: "fresh",
    catName: "新瓜速递",
    title: "凌晨三点连发十条动态后又秒删，账号疑似被盗",
    excerpt:
      "深夜突发一连串风格异常的动态，随后被迅速删除。平台方暂未回应，但技术侧消息称大概率系异常登录导致。",
    content: [
      "今日凌晨三点，某粉丝量过百万的账号突然接连发布十条风格与本人人设完全不符的动态，内容包括明显的营销广告与诱导链接。",
      "大约十分钟后，这些动态又被逐一删除，仅剩一条“手机被人拿去玩了，不好意思”的说明，但很快也被删除。",
      "有自称了解情况的技术人士透露，后台监测到异地异常登录记录，账号大概率遭遇了盗用，并非本人意愿发布。",
      "截至发稿，该账号已恢复正常，本人尚未公开解释具体原因。此类“被盗号”事件的真假往往需要平台方数据佐证，我们也会继续关注是否有后续声明。",
    ],
    time: "昨日",
    read: "21.5万",
    comment: "1103",
    tag: "账号异常",
    hot: true,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20a%20smartphone%20with%20locked%20padlock%20icon%20and%20shifting%20message%20bubbles%20and%20warning%20sign%2C%20flat%20vector%20gossip%20newsroom%20style%2C%20warm%20cream%20and%20vermilion%20red%20palette%2C%20clean%20minimal%20background&width=900&height=680&seq=news-fresh-02&orientation=portrait",
    imgAlt: "账号疑似被盗深夜异常动态插画",
  },
  {
    id: "g-2026-0907",
    cat: "respond",
    catName: "当事人回应",
    title: "就“数据造假”质疑，内容团队晒后台截图自证清白",
    excerpt:
      "面对播放量异常的质疑，团队公开后台实时截图与第三方数据报告，说明波动来自平台推荐规则调整，并非人为刷量。",
    content: [
      "近日有网友发现某条视频的播放量在一小时内从数十万骤降，随即质疑其“数据造假、买了又退”。相关讨论迅速被搬运到多个社区。",
      "针对质疑，该内容团队在次日发布长文，附上了后台实时截图与第三方数据监测报告，指出播放量波动与平台当日的推荐流量池调整有关，属正常现象而非人为干预。",
      "文中还对比了同类账号同一时段的数据变化曲线，说明并非个例。团队负责人表示欢迎任何第三方机构进行核查。",
      "从舆论反应看，大部分网友认可这份“有图有报告”的回应，也有少数声音认为应引入平台官方说明。事件整体呈降温趋势。",
    ],
    time: "2天前",
    read: "6.2万",
    comment: "201",
    tag: "数据自证",
    hot: false,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20analytics%20charts%20and%20growth%20graph%20on%20a%20dashboard%20screen%20with%20checkmark%20seal%2C%20flat%20vector%20gossip%20newsroom%20style%2C%20warm%20cream%20and%20vermilion%20red%20palette%2C%20clean%20minimal%20background&width=900&height=680&seq=news-resp-02&orientation=portrait",
    imgAlt: "数据造假质疑后台自证清白插画",
  },
  {
    id: "g-2026-0908",
    cat: "progress",
    catName: "追踪进展",
    title: "“跨平台抄袭”风波升级：律师函已发出，对比图遍布全网",
    excerpt:
      "一起跨越三个平台的创意抄袭风波不断升级，原作者已委托律所发函，多位同行也晒出对比图声援。事件进入法律解决阶段。",
    content: [
      "上月，一位原创作者指出自己的系列创意被另一头部账号“高度借鉴”，并放出了多组分镜对比图，引发创作者圈层广泛讨论。",
      "随着讨论推进，越来越多同行晒出自己“被借鉴”的经历，事件从个案演变为对行业版权环境的集中讨论，相关话题连续多日霸榜。",
      "本周，原作者通过社交媒体宣布已委托律师事务所向对方发出律师函，要求删除相关内容并公开致歉，否则将依法追责。",
      "截至发稿，被指抄袭方尚未公开回应，但有消息称其已下架争议内容。该事件走向将对行业内的原创保护产生示范意义，我们会持续追踪结果。",
    ],
    time: "3天前",
    read: "15.9万",
    comment: "847",
    tag: "抄袭维权",
    hot: false,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20two%20overlapping%20photo%20frames%20with%20copy%20and%20original%20labels%20and%20a%20scales%20of%20justice%20icon%2C%20flat%20vector%20gossip%20newsroom%20style%2C%20warm%20cream%20and%20vermilion%20red%20palette%2C%20clean%20minimal%20background&width=900&height=680&seq=news-prog-02&orientation=portrait",
    imgAlt: "跨平台抄袭律师函维权插画",
  },
  {
    id: "g-2026-0909",
    cat: "deny",
    catName: "辟谣反转",
    title: "“婚变”传闻发酵三天后：同框照流出，当事人只用两个字回应",
    excerpt:
      "一条捕风捉影的“婚变”消息在平台疯传，当事人最终晒出同框合照，配文仅“好好的”二字，堪称最高效反转。",
    content: [
      "围绕某对公众人物夫妇的“婚变”传闻，在毫无实锤的情况下被多个账号“添油加醋”式传播，连续三天霸占八卦讨论区。",
      "传闻源头是一张被过度解读的普通聚餐照：某网友仅凭“站位距离”便断言二人感情生变，随后各路分析文层出不穷。",
      "第四天上午，当事人本人晒出一张近期同框合照，配文仅两个字“好好的”，瞬间完成澄清。这条动态的点赞量在数小时内突破百万。",
      "该案例成为“看图说话式造谣”的典型反面教材。我们已在辟谣专区整理了完整的传播链条拆解，帮助读者理解这类谣言的生成逻辑。",
    ],
    time: "4天前",
    read: "33.1万",
    comment: "1522",
    tag: "高效反转",
    hot: true,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20a%20loved%20up%20couple%20silhouette%20holding%20hands%20with%20a%20red%20heart%20seal%20and%20crossed%20out%20rumor%20text%2C%20flat%20vector%20gossip%20newsroom%20style%2C%20warm%20cream%20and%20vermilion%20red%20palette%2C%20clean%20minimal%20background&width=900&height=680&seq=news-deny-03&orientation=portrait",
    imgAlt: "婚变传闻同框照辟谣反转插画",
  },
  {
    id: "g-2026-0910",
    cat: "fresh",
    catName: "新瓜速递",
    title: "颁奖礼后台“冷脸”视频走红，其实是候场困到打哈欠",
    excerpt:
      "一段“颁奖礼后台冷脸对视”的视频被配上劲爆文案疯传，实际真相却让人哭笑不得——当事人只是在候场时困到眯眼。",
    content: [
      "一段画质模糊的后台视频这两天被疯狂转发，配文渲染成“颁奖礼后台黑脸对峙，火药味十足”，相关话题迅速冲上热搜。",
      "然而原视频拍摄者很快出面澄清：当时两位当事人在长达三小时的候场中都已十分疲惫，画面里的“冷脸”其实只是困到眯眼打哈欠的瞬间。",
      "当事人在评论区也幽默回应“我连手都抬不起来了，哪来的力气对线”，令围观网友直呼“喜剧反转”。",
      "这起乌龙再次说明，脱离语境的短视频配合想象力的文案，是最容易制造假瓜的组合。真相有时就藏在一个哈欠里。",
    ],
    time: "5天前",
    read: "11.2万",
    comment: "365",
    tag: "乌龙反转",
    hot: false,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20a%20red%20carpet%20award%20backstage%20with%20spotlights%20and%20a%20yawning%20tired%20character%20silhouette%20and%20clock%2C%20flat%20vector%20gossip%20newsroom%20style%2C%20warm%20cream%20and%20vermilion%20red%20palette%2C%20clean%20minimal%20background&width=900&height=680&seq=news-fresh-03&orientation=portrait",
    imgAlt: "颁奖礼后台打哈欠乌龙视频走红插画",
  },
];

export const timelineNodes: TimelineNode[] = [
  {
    time: "08月20日",
    title: "网传截图流出，消息开始扩散",
    desc: "一张疑似内部聊天截图在各群聊传播，关于“停播退圈”的说法首次出现。",
    kind: "start",
  },
  {
    time: "08月22日",
    title: "营销号跟进，话题登榜",
    desc: "多个娱乐资讯号以“知情人士”口吻跟进，事件阅读量两天内突破百万。",
    kind: "flow",
  },
  {
    time: "08月24日",
    title: "本人发布时间线，首次辟谣",
    desc: "当事人晒出发布记录与工作排期，指出截图系旧素材拼接，完成第一轮辟谣。",
    kind: "deny",
  },
  {
    time: "08月26日",
    title: "原发布者删帖，第一轮反转完成",
    desc: "多个搬运账号删除原内容，舆论从“跟风”转向“核实信源”，热度短暂回落。",
    kind: "reverse",
  },
  {
    time: "08月29日",
    title: "新瓜浮现，事件再生波澜",
    desc: "团队发布“下月见”联动预告，疑似另有新合作官宣，事件进入新阶段。",
    kind: "fresh",
  },
];

export const hotItems: HotItem[] = [
  {
    rank: "1",
    title: "“停播半年”旧闻拼接反转，本人发时间线",
    heat: "786.4万",
    trend: "new",
    tag: "辟谣反转",
  },
  {
    rank: "2",
    title: "颁奖礼后台“冷脸”实为困到打哈欠",
    heat: "652.1万",
    trend: "up",
    tag: "乌龙反转",
  },
  {
    rank: "3",
    title: "神秘剪影联动预告，疑似头部创作者",
    heat: "598.7万",
    trend: "new",
    tag: "新瓜速递",
  },
  {
    rank: "4",
    title: "带货翻车事件品牌方介入，双方各执一词",
    heat: "511.3万",
    trend: "up",
    tag: "追踪进展",
  },
  {
    rank: "5",
    title: "凌晨异常动态后秒删，账号疑似被盗",
    heat: "487.9万",
    trend: "down",
    tag: "账号异常",
  },
  {
    rank: "6",
    title: "抄袭风波升级，律师函已发出",
    heat: "423.6万",
    trend: "up",
    tag: "维权追踪",
  },
];

export const faqItems: FaqItem[] = [
  {
    q: "扒哥黑料的内容从哪来，来源可靠吗？",
    a: "我们所有稿件均来自公开的当事人声明、官方通报、平台公告与可溯源的一手信源。每条内容都会在文中标注信息出处与更新时间，未经证实的消息一律标注为“网传待核实”，绝不把猜测当事实发布。",
  },
  {
    q: "看到“反转”标题，是不是代表之前的内容错了？",
    a: "不一定。反转通常意味着原有信息出现了新的关键补充或更正。我们会在反转稿件中完整回顾“最初说法—中间传播—最终澄清”的全过程，帮助读者看清剧情是如何一步步变化的，而非简单推翻前文。",
  },
  {
    q: "报道会不会带偏节奏、误导读者？",
    a: "我们坚持“信息分层”原则：事实与观点分开呈现，注明信息来源，保留各方说法。编辑室只做信息汇总与核对，不做情绪化审判，也不预设立场。欢迎读者通过页面底部方式对我们提出指正。",
  },
  {
    q: "如何区分“已实锤”与“待核实”的信息？",
    a: "每个内容卡片都配有彩色标签：绿色代表“已澄清/已实锤”，琥珀色代表“网传待核实”，朱红色代表“争议发酵中”。正文开头也会用一句话标注当前的信息可信度，方便快速判断。",
  },
  {
    q: "事件出现更新后，旧文章会如何处理？",
    a: "若事件有新进展，我们不会删除旧稿，而是在文章顶部添加“后续追踪”更新模块，串联最新进展，并保留历史版本，方便读者了解事件的完整演变路径，避免断章取义。",
  },
  {
    q: "想投稿或提供线索，应该怎么联系？",
    a: "欢迎通过页面底部的邮箱或订阅表单与我们联系。提供线索时请尽量附上可公开核验的信息源链接，编辑会先进行核实再决定是否跟进报道。对涉及隐私与敏感内容，我们会严格评估。",
  },
];

export const categories = [
  { key: "fresh", name: "新瓜速递" },
  { key: "deny", name: "辟谣反转" },
  { key: "respond", name: "当事人回应" },
  { key: "progress", name: "追踪进展" },
];